import React from "react";
import { AnimatePresence, motion } from "framer-motion";

/**
 * Live caption pill — frosted glass, premium, bottom-center.
 * Shows a small speaking dot when the mascot is actively speaking.
 */
export const CaptionPill = ({ text, speaking = false, show = true }) => {
    return (
        <div
            className="w-full flex justify-center pointer-events-none"
            data-testid="student-caption-pill"
        >
            <AnimatePresence mode="wait">
                {show && text ? (
                    <motion.div
                        key={text}
                        initial={{ opacity: 0, y: 24, filter: "blur(6px)" }}
                        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        exit={{ opacity: 0, y: -10, filter: "blur(6px)" }}
                        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                        className="glass-card rounded-[28px] px-10 py-5 max-w-[78%] flex items-center gap-4"
                    >
                        {speaking && (
                            <span className="flex items-center gap-1.5 shrink-0">
                                {[0, 0.15, 0.3].map((d, i) => (
                                    <motion.span
                                        key={i}
                                        className="block w-1.5 rounded-full sparkl-gradient"
                                        animate={{ height: [6, 18, 6] }}
                                        transition={{
                                            duration: 0.9,
                                            repeat: Infinity,
                                            delay: d,
                                            ease: "easeInOut",
                                        }}
                                    />
                                ))}
                            </span>
                        )}
                        <p className="text-[#1a1d20] text-base md:text-lg font-medium leading-snug tracking-tight text-left">
                            {text}
                        </p>
                    </motion.div>
                ) : null}
            </AnimatePresence>
        </div>
    );
};

export default CaptionPill;
